import type {ShellConfig} from './types'

declare const __ETS_CSS__: string

/**
 * Boot script attribute that asks for the side-sheet layout:
 * `<script data-placement="…" data-panel-layout="side-sheet">`.
 *
 * Opt-in and not part of the merchant snippet: Anagram's store demo uses it to
 * show its sheet placement the same way whatever the placement's saved panel
 * position is. Without it, every shell keeps its config's panel
 * location and mobile behaviour.
 */
export const PanelLayoutAttribute = 'data-panel-layout'
export const SideSheetPanelLayout = 'side-sheet'

/** The mobile drawer rules for `.anagram-ets-sheet`, shared with the embedded-to-sheet shell. */
export const SideSheetMobileDrawerStyles: string = typeof __ETS_CSS__ !== 'undefined' ? __ETS_CSS__ : ''

export function requestsSideSheetLayout(script: HTMLScriptElement): boolean {
  return script.getAttribute(PanelLayoutAttribute) === SideSheetPanelLayout
}

/**
 * The shell config for the side-sheet layout: the floating button opens a
 * right-hand sheet, which becomes a bottom drawer on narrow screens (see
 * `mobileDrawer` on `SideSheetPanel`). Other form factors are returned unchanged.
 */
export function applySideSheetLayout(config: ShellConfig): ShellConfig {
  return config.formFactor === 'fab' ? {...config, panelLocation: 'right'} : config
}

export function supportsSideSheetLayout(config: ShellConfig): boolean {
  return config.formFactor === 'fab'
}
